import React, { useCallback, useContext, useEffect, useState } from "react";
import { Graph } from "react-d3-graph";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Dialog,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
} from "@mui/material";
import {
  groupStyled2,
  labelStyled,
  row,
  rowFlex,
} from "../../components/700/styles";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import CustomizedSnackbars from "../300/curriculum/CustomizedSnackbars";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useLocation, useNavigate } from "react-router-dom";
import OfficeContext from "../../context/OfficeContext";
import HierarchyContext from "../../context/HierarchyContext";
import GraphInstance from "./dp";

const data = {
  nodes: [{ id: "Harry" }, { id: "Sally" }, { id: "Alice" }, { id: "kolobo" }],
  links: [
    { source: "Harry", target: "Sally" },
    { source: "Harry", target: "Alice" },
    { source: "Sally", target: "kolobo" },
    { source: "Harry", target: "kolobo" },
  ],
};

function Hierarchy() {
  let location = useLocation();
  let navigate = useNavigate();
  let api = useAxiosPrivate();

  let officeContext = useContext(OfficeContext);
  let hierarchyContext = useContext(HierarchyContext);

  let [selectedNode, setSelectedNode] = useState("");
  let [newNodes, setNewNodes] = useState([""]);
  let [action, setAction] = useState("child");
  let [name, setName] = useState(location.state.id || "");
  let [submitted, setSubmitted] = useState(false);
  let [width, setWidth] = useState(1000);
  // for snack bar
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });

  useEffect(() => {
    console.log(location.state);
    if (location.state.operation) {
      if (location.state.operation !== "add") {
        console.log(location.state);
        let data = hierarchyContext.hierarchyState.filter((node) => {
          return node.type === location.state.id;
        });
        //debugger;
        console.log(data);
        loadTree(data);
      }
    }
  }, []);

  let mygraph = new GraphInstance();
  mygraph.addNode([{ value: "root", x: window.innerWidth / 3, y: 10 }]);
  const [graph, setGraph] = useState({ mygraph: mygraph });

  const myConfig = {
    directed: true,
    width: width,

    nodeHighlightBehavior: true,
    node: {
      color: "lightgreen",
      size: 200,
      highlightStrokeColor: "blue",
    },
    link: {
      highlightColor: "lightblue",
    },
  };

  // Callback to handle click on the graph.
  // @param {Object} event click dom event
  const onClickGraph = function (event) {
    //window.alert("Clicked the graph background");
  };

  const onClickNode = function (nodeId, node) {
    //alert(window.innerWidth);
    //console.log(nodeId, node);
    //let date = `${new Date().getMilliseconds()}`;
    //setSelectedNode(nodeId);
    //window.alert("Clicked node ${nodeId} in position (${node.x}, ${node.y})");
  };

  const onDoubleClickNode = function (nodeId, node) {
    //window.alert(
    //  "Double clicked node ${nodeId} in position (${node.x}, ${node.y})"
    //);
  };

  const onRightClickNode = function (event, nodeId, node) {
    //window.alert(
    //  "Right clicked node ${nodeId} in position (${node.x}, ${node.y})"
    //);
  };

  const onMouseOverNode = function (nodeId, node) {
    //window.alert(
    //  `Mouse over node ${nodeId} in position (${node.x}, ${node.y})`
    //);
  };

  const onMouseOutNode = function (nodeId, node) {
    //window.alert(`Mouse out node ${nodeId} in position (${node.x}, ${node.y})`);
  };

  const onClickLink = function (source, target) {
    //window.alert(`Clicked link between ${source} and ${target}`);
  };

  const onRightClickLink = function (event, source, target) {
    //window.alert("Right clicked link between ${source} and ${target}");
  };

  const onMouseOverLink = function (source, target) {
    //window.alert(`Mouse over in link between ${source} and ${target}`);
  };

  const onMouseOutLink = function (source, target) {
    //window.alert(`Mouse out link between ${source} and ${target}`);
  };

  const onNodePositionChange = function (nodeId, x, y) {
    //window.alert(`Node ${nodeId} moved to new position x= ${x} y= ${y}`);
    setGraph((prev) => {
      prev.mygraph.nodes.forEach((node) => {
        if (node.value == nodeId) {
          node.x = x;
          node.y = y;
        }
      });
      return { ...prev };
    });
  };

  // Callback that's called whenever the graph is zoomed in/out
  // @param {number} previousZoom the previous graph zoom
  // @param {number} newZoom the new graph zoom
  const onZoomChange = function (previousZoom, newZoom) {
    //window.alert(`Graph is now zoomed at ${newZoom} from ${previousZoom}`);
  };

  //
  let handleChange = (e, index, newValue) => {
    if (newValue) {
      console.log(newValue);
      let newState = newNodes;
      newState[index] = newValue;
      console.log(newState);
      setNewNodes([...newState]);
    } else {
      let newState = newNodes;
      newState[index] = e.target.value;
      console.log(newState);
      setNewNodes([...newState]);
    }
  };

  let removeNode = (index) => {
    setNewNodes((prev) => {
      return prev.filter((node, i) => index !== i);
    });
  };

  let addNodeToState = () => {
    //if it is children
    if (
      newNodes.reduce((total, current) => {
        return total || Boolean(current);
      }, false)
    ) {
      let edges = [];

      if (action == "child")
        edges = newNodes.map((node) => {
          return { source: selectedNode, target: node };
        });
      else {
        edges = newNodes.map((node) => {
          return { source: node, target: selectedNode };
        });
      }

      console.log("Here are the edges", newNodes, edges);
      setGraph((prev) => {
        let newOne = {
          mygraph: prev.mygraph.addNode(
            newNodes.map((node) => {
              return {
                value: node,
                x: null,
                y: null,
              };
            })
          ),
        };
        newOne = {
          mygraph: prev.mygraph.addEdge(edges),
        };
        //alert(JSON.stringify(newOne, null, 2));
        return { mygraph: prev.mygraph };
      });
      setNewNodes([""]);
      if (submitted) {
        setSnackBarOpen(false);
        setMessage({ message: "", type: "" });
      }
    }
  };

  let submitForm = () => {
    console.log(graph.mygraph.edges);
    let rootRemoved = graph.mygraph.edges.reduce((total, current) => {
      //debugger;
      console.log(current);

      let child = graph.mygraph.nodes.filter(
        (node) => node.value == current.target
      )[0];

      if (current.source == "root") {
        return [
          ...total,
          {
            child: officeContext.officeState.filter(
              (val) => val.name === current.target
            )[0].id,
            parent: null,
            x: child.x,
            y: child.y,
          },
        ];
      } else {
        return [
          ...total,
          {
            child: officeContext.officeState.filter(
              (val) => val.name === current.target
            )[0].id,
            parent: officeContext.officeState.filter(
              (val) => val.name === current.source
            )[0].id,
            x: child.x,
            y: child.y,
          },
        ];
      }
    }, []);
    let value = { tree: rootRemoved, name: name };
    alert(JSON.stringify(value, null, 2));
    if (!rootRemoved.length) {
      setSnackBarOpen(true);
      setMessage({ message: "Tree can not be empty", type: "error" });
      return;
    }

    if (location.state.operation == "add") {
      alert("adding");
      api
        .post("hierarchy/addHierarchy", value)
        .then((res) => {
          alert(JSON.stringify(res.data));
          setSnackBarOpen(true);
          setMessage({ type: "success", message: "Added Successfully" });
        })
        .catch((err) => {
          alert(JSON.stringify(err.response));
          setSnackBarOpen(true);
          setMessage({ type: "error", message: err.response.data.message });
        });
    }

    if (location.state.operation == "edit") {
      api
        .patch("hierarchy/updateHierarchy", {
          ...value,
          oldName: location.state.id,
        })
        .then((res) => {
          alert(JSON.stringify(res.data));
          navigate("../", {
            state: {
              open: true,
              message: { type: "success", message: "Updated Successfully" },
            },
          });
        })
        .catch((err) => {
          alert(JSON.stringify(err.response));
          setSnackBarOpen(true);
          setMessage({ type: "error", message: err.response.data.message });
        });
    }

    // api.post("hierarchy/addHierarchy", value);
  };
  let loadTree = useCallback(() => {
    console.log("called");
    console.log("444444444444444444444");

    let data = hierarchyContext.hierarchyState.filter((node) => {
      return node.type == location.state.id;
    });
    console.log(data);
    let nodes = {};
    let links = [];
    for (let entry of data) {
      let parent = entry.parent?.name;
      let child = entry.child?.name;

      if (entry.parent.id !== null) {
        links.push({ source: parent, target: child });
      } else {
        links.push({
          source: "root",
          target: child,
        });
      }
      if (!nodes[child]) {
        nodes[child] = {
          value: child,
          x: parseFloat(entry.x),
          y: parseFloat(entry.y),
        };
      }
    }
    //debugger;
    console.log("loading....");
    console.log([...Object.values(nodes)], links);
    setGraph((prev) => {
      let newOne = {
        mygraph: prev.mygraph.addNode([...Object.values(nodes)]),
      };
      newOne = {
        mygraph: prev.mygraph.addEdge(links),
      };
      //alert(JSON.stringify(newOne, null, 2));
      return { mygraph: prev.mygraph };
    });

    //alert(JSON.stringify(newOne, null, 2));
  }, []);

  return (
    <>
      <Box sx={{ display: "flex", height: "100%" }}>
        {location.state.operation == "view" ? (
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "200",
              height: "100vh",
              minWidth: "100vw",
              padding: "0px",
              backgroundColor: "rgba(1,2,3,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "2.5rem",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                overflow: "scroll",
              }}
            >
              <CloseIcon
                fontSize="large"
                sx={{ position: "absolute", top: "2.6rem", right: "3.2rem" }}
                onClick={() => navigate("../")}
                s
              />

              <Graph
                id="graph-id" // id is mandatory, if no id is defined rd3g will throw an error
                data={graph.mygraph.constructTree()}
                config={myConfig}
                onClickGraph={onClickGraph}
                onClickNode={onClickNode}
                onDoubleClickNode={onDoubleClickNode}
                onRightClickNode={onRightClickNode}
                onClickLink={onClickLink}
                onRightClickLink={onRightClickLink}
                onMouseOverNode={onMouseOverNode}
                onMouseOutNode={onMouseOutNode}
                onMouseOverLink={onMouseOverLink}
                onMouseOutLink={onMouseOutLink}
                onNodePositionChange={onNodePositionChange}
                onZoomChange={onZoomChange}
              />
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              height: "100%",
              width: "100%",
              padding: "0px",
              backgroundColor: "rgba(1,2,3,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                backgroundColor: "white",
                overflow: "scroll",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/*<pre>
                {JSON.stringify(graph.mygraph.constructTree(), null, 2)}
              </pre>*/}
              <Graph
                id="graph-id" // id is mandatory, if no id is defined rd3g will throw an error
                data={graph.mygraph.constructTree()}
                config={myConfig}
                onClickGraph={onClickGraph}
                onClickNode={onClickNode}
                onDoubleClickNode={onDoubleClickNode}
                onRightClickNode={onRightClickNode}
                onClickLink={onClickLink}
                onRightClickLink={onRightClickLink}
                onMouseOverNode={onMouseOverNode}
                onMouseOutNode={onMouseOutNode}
                onMouseOverLink={onMouseOverLink}
                onMouseOutLink={onMouseOutLink}
                onNodePositionChange={onNodePositionChange}
                onZoomChange={onZoomChange}
              />
              {/*{constructTree(tree.mytree.root)}*/}
              {/*<pre>{JSON.stringify(tree.mytree.constructArray(), null, 2)}</pre>*/}
            </Box>
          </Box>
        )}

        {location.state.operation !== "view" && (
          <Box
            sx={{
              //...rowFlex,
              //width: "fit-content",
              gap: "1.3rem",
              display: "flex",
              flexDirection: "column",
              overflowY: "scroll",
              border: "1px solid",
              borderColor: "primary.lighter3",
              padding: "20px 20px",
              height: "80vh",
              //overflow: "auto",
              scrollbarWidth: "none,",
              //-ms-overflow-style: none;
            }}
          >
            <FormControl sx={groupStyled2}>
              <FormLabel htmlFor="name" sx={labelStyled}>
                Hierarchy Name
              </FormLabel>
              <TextField
                name={`name`}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                error={submitted && (name ? false : true)}
                helperText={submitted && !name && "Hierarchy name is required"}
              />
            </FormControl>
            <FormControl sx={groupStyled2}>
              <FormLabel htmlFor="selected" sx={labelStyled}>
                Selected Node
              </FormLabel>
              {/*<TextField name={`selected`} value={selectedNode} select>*/}
              <Autocomplete
                id={`selected`}
                name={"selected"}
                value={selectedNode}
                onChange={(e, newValue) => {
                  setSelectedNode(newValue);
                  //
                }}
                //options={options.filter((option) => {
                //  return (
                //    !tree.mytree.find(option) && !newNodes.includes(option)
                //  );
                //}, [])}
                options={[...graph.mygraph.nodes]?.map((option) => {
                  return option.value;
                })}
                renderInput={(params) => (
                  <TextField name={`node`} {...params} />
                )}
                fullWidth
              />
              {/*</TextField>*/}
            </FormControl>
            <FormControl sx={groupStyled2}>
              <FormLabel htmlFor="newnode" sx={labelStyled}>
                New Node
              </FormLabel>
              {newNodes.map((newNode, index) => {
                return (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    {/*<TextField
                  name={`newnode` + index}
                  value={newNode}
                  onChange={(e) => {
                    handleChange(e, index);
                  }}
                  select
                  fullWidth
                >
                  {options
                    .filter((option) => {
                      return (
                        !tree.mytree.find(option) && !newNodes.includes(option)
                      );
                    }, [])
                    .map((opt) => {
                      return (
                        <MenuItem key={opt} value={opt}>
                          {opt}
                        </MenuItem>
                      );
                    })}
                </TextField>*/}
                    <Autocomplete
                      id={`newNode${index}`}
                      value={newNode}
                      onChange={(e, newValue) => {
                        console.log(newValue);
                        handleChange(e, index, newValue);
                        //
                      }}
                      //options={options.filter((option) => {
                      //  return (
                      //    !tree.mytree.find(option) && !newNodes.includes(option)
                      //  );
                      //}, [])}
                      options={officeContext.officeState
                        .map((option) => `${option.name}`)
                        .filter((name) => {
                          return (
                            !graph.mygraph.nodes.reduce((total, node) => {
                              return total || node.value == name;
                            }, false) && !newNodes.includes(name)
                          );
                        })}
                      renderInput={(params) => (
                        <TextField name={`newNode${index}`} {...params} />
                      )}
                      fullWidth
                    />
                    {index == 0 ? (
                      <Tooltip title="Add">
                        <IconButton
                          onClick={(e) => {
                            setNewNodes((prev) => [...prev, ""]);
                          }}
                          disabled={action !== "parent" ? false : true}
                        >
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title="Remove"
                        onClick={(e) => {
                          removeNode(index);
                        }}
                      >
                        <IconButton>
                          <RemoveCircleOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                );
              })}
              {selectedNode == "root" && newNodes.length > 1 && (
                <Alert severity={"warning"}>
                  Only the first node will be added
                </Alert>
              )}
            </FormControl>{" "}
            <FormControl sx={groupStyled2}>
              <FormLabel
                id="demo-radio-buttons-group-label"
                sx={{ labelStyled }}
              >
                Set us
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="child"
                name="radio-buttons-group"
                onChange={(e) => {
                  setAction(e.target.value);
                }}
                value={action}
              >
                <FormControlLabel
                  value="parent"
                  control={<Radio />}
                  label="Parent"
                  disabled={selectedNode == "root" ? true : false}
                />
                <FormControlLabel
                  value="child"
                  control={<Radio />}
                  label="Child"
                />
              </RadioGroup>
            </FormControl>
            <Box
              sx={{
                ...groupStyled2,
                display: "flex",
                gap: "1.8rem",
                justifyContent: "flex-end",
                width: "100%",
                margin: "1rem 0rem",
                paddingTop: "2rem",
              }}
            >
              <Button
                sx={{ alignSelf: "flex-start" }}
                variant="outlined"
                onClick={() => {
                  addNodeToState();
                }}
              >
                Add
              </Button>
              <Button
                sx={{ alignSelf: "flex-start" }}
                variant="outlined"
                onClick={() => {
                  if (selectedNode !== "root")
                    setGraph((prev) => {
                      let newOne = {
                        mygraph: prev.mygraph.removeNode(selectedNode),
                      };
                      return { mygraph: prev.mygraph };
                    });
                }}
              >
                Remove
              </Button>
            </Box>
          </Box>
        )}
      </Box>
      <CustomizedSnackbars {...{ snackBarOpen, setSnackBarOpen, message }} />
      <Box>
        <Box
          sx={{
            ...groupStyled2,
            display: "flex",
            gap: "1.8rem",
            justifyContent: "flex-end",
            width: "100%",
            margin: "1rem 0rem",
            paddingTop: "2rem",
          }}
        >
          <Button
            sx={{ alignSelf: "flex-start", color: "teritiary.lighter1" }}
            //variant="disabled"
            onClick={() => {
              navigate("../");
            }}
          >
            Cancel
          </Button>
          <Button
            sx={{
              alignSelf: "flex-start",
              backgroundColor: "secondary.lighter1",
              //color: "white",
            }}
            variant="contained"
            onClick={() => {
              if (!name) {
                setSubmitted(true);
              } else {
                submitForm();
              }
            }}
            disabled={submitted && (name ? false : true)}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default Hierarchy;
